module.exports = __webpack_public_path__ + "fountain.jpg?a14536a21b189538d6e29ea5da8963a6";